// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios';
import './system/url';
import ElementUI from 'element-ui';
import base from './system/base'
import {mySelect,mySelectAll,myZhiFu,mySubmit} from './system/http'
import ExcelDaoChu from '@/components/ExcelDaoChu'
import XLSX from '../static/xslx'

Vue.use(XLSX)

Vue.prototype.mySubmit = mySubmit;
Vue.prototype.mySelect = mySelect;
Vue.prototype.myZhiFu = myZhiFu;
Vue.prototype.mySelectAll = mySelectAll;
Vue.prototype.$http = axios;
Vue.config.productionTip = false
Vue.use(ElementUI, {size: 'small'});
Vue.component('excel-dao-chu', ExcelDaoChu)
Vue.use(base)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js